const WHATSAPP_NUMBER = "543764868904";
const DEFAULT_MESSAGE = "Quiero hablar sobre BRANDWAY©";

export const getWhatsAppLink = (message: string = DEFAULT_MESSAGE): string => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const WHATSAPP_URL = getWhatsAppLink();
